import { useConfiguration } from '../../../../../../store/configurationStore';
import { SingleColumnSectionProps } from './types';

export const useSingleColumnSection = (props: SingleColumnSectionProps) => {
  const { sectionId } = props;
  const { getValidationForSection } = useConfiguration();

  // Read validation from store
  const validationResult = getValidationForSection(sectionId);

  return {
    validationResult,
  };
};
